import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('ModalFooter', null, { withChildren: true });
